import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DEFAULT_CURRENCY_ABREVIATURE } from "features/Contactos/constants"
import { InputNumber } from "primereact/inputnumber"
import { Slider } from "primereact/slider"
import { useTranslation } from "react-i18next"

const ImporteFilter = ({
  importeSliderActive,
  precioLowerLimit,
  handleOnChangeLowerPrecioRange,
  handleOnChangeHigherPrecioRange,
  initialMinPrecioRange,
  initialMaxPrecioRange,
  preciosRange,
  handleChangePrecioRange,
  precioUpperLimit,
  title,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <>
      <div className='px-2 p-fluid p-grid p-formgrid justify-content-center'>
        <div className='p-1 p-field col-12 '>
          <div className='filter-title'>
            <FontAwesomeIcon icon={["fal", "euro-sign"]} />
            <h5>{title || t("filtros.importe.title")}</h5>
          </div>
          {importeSliderActive ? (
            <div className='p-2 mt-3 p-field d-flex fluid filter-slider'>
              <Slider
                className='w-100'
                value={preciosRange}
                onChange={handleChangePrecioRange}
                step={0.5}
                min={initialMinPrecioRange}
                max={initialMaxPrecioRange}
                range
              />
            </div>
          ) : null}
        </div>
      </div>
      <div className='p-fluid p-grid'>
        <div className='px-2 p-fluid p-grid p-formgrid justify-content-center'>
          <div className='p-0 p-field col-5 d-flex p-dir-col align-items-start'>
            <label htmlFor='importeDesde'>
              {t("filtros.importe.fromLabel")} (€)
            </label>
            <InputNumber
              value={precioLowerLimit}
              onChange={handleOnChangeLowerPrecioRange}
              minFractionDigits={2}
              mode='currency'
              currency={DEFAULT_CURRENCY_ABREVIATURE}
            />
          </div>
          <div className='mt-4 p-field d-flex justify-content-center col-1 align-items-center'>
            -
          </div>
          <div className='p-0 p-field col-5 d-flex p-dir-col align-items-start'>
            <label htmlFor='importeHasta'>
              {t("filtros.importe.toLabel")} (€)
            </label>
            <InputNumber
              value={precioUpperLimit}
              onChange={handleOnChangeHigherPrecioRange}
              minFractionDigits={2}
              mode='currency'
              currency={DEFAULT_CURRENCY_ABREVIATURE}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ImporteFilter
